function searchFocusBlur() {
    var el = document.querySelector('.search-text')
    el.onfocus = () => {el.parentElement.parentElement.classList.add('focus')}
    el.onblur  = () => {el.parentElement.parentElement.classList.remove('focus')}
}
window.addEventListener('load', searchFocusBlur)

const slideDown = elem => elem.style.height = `${elem.scrollHeight}px`
const slideUp   = elem => elem.style.height = 0
function toggleList() {
    var list = this.nextElementSibling
        if (list.classList.contains('opened')) {
            list.classList.remove('opened')
            slideUp(list)
        } else {
            list.classList.add('opened')
            slideDown(list)
    }
}
function openFirstList() {
    var list = document.querySelector('.vacancies h2').nextElementSibling
    list.classList.add('opened')
    slideDown(list)
}
function setToggler() {
    var sectionHeaders = document.querySelectorAll('.vacancies h2')
    if (sectionHeaders.length > 0) {
        for (let i = 0; i < sectionHeaders.length; i++) {
            sectionHeaders[i].addEventListener('click', toggleList)
        }
    }
}
window.addEventListener('load', setToggler)
window.addEventListener('load', openFirstList)

function chooseOption() {
    // console.log(this)
    var item 		= this,
        optionName 	= item.innerHTML,
        option 		= item.dataset.value,
        current 	= item.parentElement.previousElementSibling,
        others 		= item.parentElement.querySelectorAll('.selected')
    if (others) {
        for (let i = 0; i < others.length; i++) {
            others[i].classList.remove('selected')
        }
    }
    current.innerHTML = optionName
    item.classList.add('selected')
    closeSelect()
    // открыть выбранную секцию
    if (jsVacancies) renderVacanciesList([jsVacancies][0].filter(item => item.CODE.indexOf(option) > -1))
}

function renderVacanciesList(ar) {
    if (ar) {
        // console.log(ar)
        var to = document.querySelector('.items-list'),
            list = ''

        for (let i = 0; i < ar.length; i++) {
            list += '<div class="' + ar[i]['CODE'] +'">'
            list += '<h2><span>' + ar[i]['NAME'] +'</span><span class="counts">' + ar[i]["ELEMENT_CNT"] + '</span></h2>'
            list += '<div class="list">'
            if (typeof(ar[i]['CHILDS']) !== "undefined" && (ar[i]['CHILDS'] !== null)) {
            //     list += '<p>Вакансии не найдены</p>'
            // } else {
                var last = ar[i]['CHILDS'].length
                for (let k = 0; k < last; k++) {
                    if (k % 2 == 0) {
                        list += '<div class="flex">'
                    }
                    list += '<div class="half">'
                    list += '<div class="bordered vacancy-card">'
                    list += '<div class="flex column">'
                    list += '<div class="title bigtext Semibold dark">' + ar[i]['CHILDS'][k]['NAME'] + '</div>'
                    list += '<div>' + ar[i]['CHILDS'][k]['DEPT'] +'</div>'
                    list += '<div class="anons">' + ar[i]['CHILDS'][k]['ANONS'] +'</div>'
                    list += '<div class="descr">' + ar[i]['CHILDS'][k]['DESCR'] +'</div>'
                    list += '</div>'
                    list += '<div class="opener">'
                    list += '<a class="arrowlink next" href="' + ar[i]['CODE'] + '/' + ar[i]['CHILDS'][k]['CODE'] + '/"></a>'
                    list += '</div>'
                    list += '</div>'
                    list += '</div>'
                    if (k%2 == 1 || k+1 == last) {
                        list += '</div>'
                    }
                }
            }
            list += '</div>'    
            list += '</div>'
        }
        
        to.innerHTML = list
        setToggler()
        openFirstList()
    }
}